import { ListedInstrument, OrderType, TradingSession, useOrderTradingSessionCommon } from '@eih-netbroker/common';
import { useOptions } from '../../../../shared/services/useOptions';
import { useUserSettings } from '../../../../shared/services/user-settings/useUserSettings';

type UseOrderTradingSessionOutput = {
  getInitialTradingSession: (
    instrument: ListedInstrument | null | undefined,
    orderType: OrderType,
  ) => TradingSession | undefined;
};

export const useOrderTradingSession = (): UseOrderTradingSessionOutput => {
  const { getTradingSessionOptions } = useOptions();
  const { userInterfaceSettings } = useUserSettings();
  const { getInitialTradingSession } = useOrderTradingSessionCommon({
    getTradingSessionOptions,
    userInterfaceSettings,
  });

  return {
    getInitialTradingSession,
  };
};
